import { useMessage } from "@tm/utils"
import { useCallback, useEffect, useMemo, useState } from "react"
import { FullsizeDialog } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { CustomArticleItemResponse, useCustomArticlesDefaults, useShowCustomArticleItems } from "@tm/data/basket"
import { OwnArticlestByCategory } from "@bundles/compilations/components/OwnArticlestByCategory"
import { CustomArticleGenartList, CustomMvcArticle } from "../../../model"

export default function ReplaceArticleModal() {
    const [messageWindow, setMessageWindow] = useState<Window | undefined>(undefined)
    const [genartNr, setGenartNr] = useState<string>("")
    const [openModal, setOpenModal] = useState(false)
    const [enableMvcMessageSend, setEnableMvcMessageSend] = useState(false)
    const [lubricantName, setLubricantName] = useState("")
    const { translateText } = useLocalization()

    const { categoryId, customArticlesDefaults, customArticlesDefaultsError } = useCustomArticlesDefaults(+genartNr)
    const { categories } = customArticlesDefaults || {}

    const { data: { pages } = {}, isError, isLoading, isFetched } = useShowCustomArticleItems({ productGroupIdsFilter: categoryId })
    const customArticles = useMemo(() => pages?.flatMap((x) => x.data) ?? [], [pages])

    const sendCustomArticleToMvc = useCallback(
        (customArticleList: CustomArticleGenartList[] | undefined) => {
            if (messageWindow) {
                messageWindow.postMessage({ customArticles: customArticleList }, "*")
                setEnableMvcMessageSend(false)
            }
        },
        [messageWindow]
    )

    function hanldeClose() {
        setOpenModal(false)
    }

    function onConsumableReplace(selectedConsumable: CustomArticleItemResponse) {
        const customMvcArticle = { ...selectedConsumable, lubricantName } as CustomMvcArticle
        sendCustomArticleToMvc([{ genart: +genartNr, customArticle: customMvcArticle }])
        hanldeClose()
    }

    function getDefaultOrFirstArticle(articles: CustomArticleItemResponse[] | undefined) {
        return articles?.find((customArticle) => customArticle.isDefaultForCategory) ?? articles?.[0]
    }

    function mapArticlesToList(articles: CustomArticleItemResponse[] | undefined) {
        const articleListGroupArray: CustomArticleGenartList[] = []

        const grouppedArticles = articles?.reduce((acc, curr) => {
            const productGroupList = categories?.find((x) => x.categoryId === curr.categoryId)?.productGroupIds
            productGroupList?.forEach((genart) => {
                if (!genart) {
                    return
                }

                const customArticleEntry = acc.get(genart)
                if (customArticleEntry) {
                    acc.set(genart, [...customArticleEntry, curr])
                } else {
                    acc.set(genart, [curr])
                }
            })
            return acc
        }, new Map<number, CustomArticleItemResponse[]>())

        grouppedArticles?.forEach((groupArticle, genArt) => {
            articleListGroupArray.push({ genart: genArt, customArticle: getDefaultOrFirstArticle(groupArticle) })
        })

        return articleListGroupArray
    }

    useEffect(() => {
        if (isLoading || (!isFetched && isLoading === false) || !enableMvcMessageSend) {
            return
        }

        if (isError || customArticlesDefaultsError) {
            sendCustomArticleToMvc(undefined)
            return
        }

        if (customArticles.length > 0 && customArticlesDefaults?.categories) {
            sendCustomArticleToMvc(mapArticlesToList(customArticles))
        }
        // This dep array should remain like this!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        customArticles,
        isLoading,
        isError,
        isFetched,
        sendCustomArticleToMvc,
        customArticlesDefaultsError,
        enableMvcMessageSend,
        customArticlesDefaults?.categories,
    ])

    useMessage((data, source) => {
        if (data.getCustomArticle) {
            const genartNrRequest = data.getCustomArticle.genartNr
            const openModalRequest = data.getCustomArticle.openModal
            setLubricantName(data.getCustomArticle.lubricantName)
            setEnableMvcMessageSend(!openModalRequest)
            setMessageWindow(source)
            setGenartNr(genartNrRequest)
            setOpenModal(openModalRequest)
        }
    })

    if (!openModal) {
        return null
    }
    return (
        <FullsizeDialog open>
            <OwnArticlestByCategory
                title={translateText(categoryId ?? 616)}
                productGroupId={+genartNr}
                onConsumableReplace={onConsumableReplace}
                onClose={hanldeClose}
            />
        </FullsizeDialog>
    )
}
